import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

import { BREAKPOINTS } from '@/constants';

import Space from '@/components/Space';

import BaseItem from './Item';
import { GridStructure, LabeledColumn } from './Grid.shared';

function NarrowColumns() {
  const gridTemplateColumns = '90px 90px';

  return (
    <OuterWrapper>
      <Wrapper>
        <BackLayer>
          <GridStructure
            style={{
              gridTemplateColumns,
              gap: 2,
            }}
          >
            <LabeledColumn>C1</LabeledColumn>
            <LabeledColumn>C2</LabeledColumn>
          </GridStructure>
          <Annotation
            alt="Arrow illustrating the leftover space"
            src="/images/interactive-guide-to-grid/extra-space.svg"
          />
        </BackLayer>
        <Layer>
          <ChildWrapper
            style={{
              gridTemplateColumns,
              justifyItems: 'center',
            }}
          >
            <Item
              style={{
                width: 82,
              }}
            />
            <Item
              style={{
                width: 82,
              }}
            />
          </ChildWrapper>
        </Layer>
      </Wrapper>
    </OuterWrapper>
  );
}

const OuterWrapper = styled(Space)`
  display: flex;
  justify-content: center;
  margin-left: -32px;
  margin-right: -32px;
  margin-bottom: 64px;
  padding: 32px;
  padding-top: 64px;
  border-radius: 0px;
  background: var(--syntax-bg);

  @media ${BREAKPOINTS.smAndSmaller} {
    padding-right: 48px;
  }

  @media ${BREAKPOINTS.mdAndLarger} {
    border-radius: 8px;
  }
`;

const Wrapper = styled(motion.div)`
  position: relative;
  width: 400px;
  max-width: 100%;
  height: 190px;
`;

const Layer = styled(motion.div)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  transition: transform 500ms;
  will-change: transform;
`;

const BackLayer = styled(Layer)`
  background: repeating-linear-gradient(
    45deg,
    hsl(210deg 40% 80% / 0.06) 0px,
    hsl(210deg 40% 80% / 0.06) 10px,
    hsl(210deg 40% 80% / 0) 10px,
    hsl(210deg 40% 80% / 0) 20px
  );
`;

const ChildWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  gap: 2px;
  padding: 2px;
`;

const Item = styled(BaseItem)`
  margin: 0;
`;

const Annotation = styled.img`
  position: absolute;
  top: -35px;
  right: -24px;
  width: 160px;
  /* Don't let the image overlap the columns on small devices */
  max-width: 42%;
`;

export default NarrowColumns;
